import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import useVisibleCallList from '@modules/SoftPhoneModule/useVisibleCallList';
import { CallBar } from '../CallBar/CallBar';
import useInboxState from '@modules/InboxModule/hooks/useInboxState';

const CallBarManager = () => {
  const { callAttributes } = usePhoneState();
  const visibleCallList = useVisibleCallList();
  const { selectedTaskId } = useInboxState();

  const allCallsHeld = visibleCallList.every((call) => call.held);

  return visibleCallList.map((call) => {
    const attributes = {
      ...callAttributes[call.callId],
      queueIds: callAttributes[call.callId]?.queueIds
        ? [...callAttributes[call.callId].queueIds]
        : [],
      traits: callAttributes[call.callId]?.traits
        ? [...callAttributes[call.callId].traits]
        : [],
    };

    // if all calls are held, show the call bar for selected task
    const showSelectedCallBar =
      allCallsHeld &&
      !!selectedTaskId &&
      selectedTaskId === attributes.pcsConversationSid;

    return (
      <CallBar
        key={call.callId}
        callState={call}
        show={!call.held || showSelectedCallBar}
      />
    );
  });
};

export default CallBarManager;
